<script setup lang="ts">
const systemSetup = useSystemStore()
const { setup } = storeToRefs(systemSetup)
const copyrightText = computed(() => `Copyright © ${new Date().getFullYear()}. All rights reserved.`)
</script>

<template>
  <UFooter v-if="setup?.nr_portal">
    <template #left>
      <p class="text-sm text-(--grid-chrome-text)">
        {{ copyrightText }}
      </p>
    </template>

    <template #right>
      <p class="text-sm text-(--grid-chrome-text)">
        {{ `Api ${setup.nr_clinux} Web ${setup.nr_portal} Dba ${setup.nr_banco}` }}
      </p>
    </template>
  </UFooter>
</template>
